"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTranslations = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var createContext = React.createContext, createElement = React.createElement, Fragment = React.Fragment;
var defaultInterpolate = function (strs) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var list = [];
    var i = 0;
    for (; i < args.length; i++) {
        list.push(strs[i]);
        list.push(args[i]);
    }
    list.push(strs[i]);
    return createElement.apply(void 0, tslib_1.__spreadArrays([Fragment, {}], list));
};
var translationInterpolate = function (values) { return function (strs) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var list = [];
    var i = 0;
    for (; i < args.length; i++) {
        list.push(strs[i]);
        list.push(values[args[i]]);
    }
    list.push(strs[i]);
    return createElement.apply(void 0, tslib_1.__spreadArrays([Fragment, {}], list));
}; };
exports.createTranslations = function (ns) {
    var _a;
    if (ns === void 0) { ns = 'main'; }
    var context = createContext({});
    var Consumer = context.Consumer;
    var Provider = (_a = /** @class */ (function (_super) {
            tslib_1.__extends(class_1, _super);
            function class_1(props) {
                var _a;
                var _this = _super.call(this, props) || this;
                _this.load = function (locale, ns) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var translations;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!this.state.map[locale]) {
                                    this.state.map[locale] = {};
                                }
                                if (!!this.state.map[locale][ns]) return [3 /*break*/, 2];
                                this.state.map[locale][ns] = {};
                                this.setState(tslib_1.__assign({}, this.state));
                                return [4 /*yield*/, this.props.loader(locale, ns)];
                            case 1:
                                translations = _a.sent();
                                this.state.map[locale][ns] = translations;
                                this.setState(tslib_1.__assign({}, this.state));
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                }); };
                _this.setLocale = function (locale) {
                    if (locale === _this.state.locale)
                        return;
                    if (!_this.state.map[locale])
                        _this.state.map[locale] = {};
                    _this.setState({
                        locale: locale,
                    });
                };
                _this.createT = function (nss) {
                    if (nss === void 0) { nss = [_this.props.ns]; }
                    var locale = _this.state.locale;
                    var translationsNamespaced = _this.state.map[locale];
                    for (var _i = 0, nss_1 = nss; _i < nss_1.length; _i++) {
                        var ns_1 = nss_1[_i];
                        if (!translationsNamespaced[ns_1]) {
                            _this.load(locale, ns_1).catch(function (err) { return console.error(err); });
                        }
                    }
                    var t = (function (key) {
                        var args = [];
                        for (var _i = 1; _i < arguments.length; _i++) {
                            args[_i - 1] = arguments[_i];
                        }
                        for (var _a = 0, _b = [locale, _this.props.defaultLocale]; _a < _b.length; _a++) {
                            var currentLocale = _b[_a];
                            if (!currentLocale)
                                break;
                            var translationsNamespaced_1 = _this.state.map[currentLocale];
                            for (var _c = 0, nss_2 = nss; _c < nss_2.length; _c++) {
                                var namespace = nss_2[_c];
                                var translations = translationsNamespaced_1[namespace];
                                var value = translations[key];
                                if (value !== undefined) {
                                    return typeof value === 'function'
                                        ? value(translationInterpolate(args)) : (value || key);
                                }
                            }
                        }
                        return key;
                    });
                    t.t = function (key) { return function (strs) {
                        var args = [];
                        for (var _i = 1; _i < arguments.length; _i++) {
                            args[_i - 1] = arguments[_i];
                        }
                        var result = t.apply(void 0, tslib_1.__spreadArrays([key], args));
                        if (typeof result === 'object')
                            return result;
                        else if (result !== key)
                            return createElement(Fragment, {}, result);
                        else
                            return defaultInterpolate.apply(void 0, tslib_1.__spreadArrays([strs], args));
                    }; };
                    return t;
                };
                var _b = props.map, map = _b === void 0 ? {} : _b, locale = props.locale, defaultLocale = props.defaultLocale, ns = props.ns;
                // Normalize translation map.
                if (!map[defaultLocale])
                    map[defaultLocale] = (_a = {}, _a[ns] = {}, _a);
                else if (!map[defaultLocale][ns])
                    map[defaultLocale][ns] = {};
                _this.state = {
                    locale: locale,
                    ns: ns,
                    map: map,
                    load: _this.load,
                    setLocale: _this.setLocale,
                    createT: _this.createT,
                };
                if (locale !== defaultLocale) {
                    _this.load(locale, ns);
                }
                return _this;
            }
            class_1.prototype.shouldComponentUpdate = function (nextProps) {
                if (nextProps.locale !== this.props.locale) {
                    this.setLocale(nextProps.locale);
                }
                return true;
            };
            ;
            class_1.prototype.render = function () {
                return React.createElement(context.Provider, {
                    value: this.state,
                    children: this.props.children,
                });
            };
            return class_1;
        }(React.Component)),
        _a.defaultProps = {
            locale: 'en',
            defaultLocale: 'en',
            ns: ns,
        },
        _a);
    var defaultT = (function (k) { return k; });
    defaultT.t = function (key) { return function (strs) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return defaultInterpolate(strs, args);
    }; };
    var useT = function (namespaces) {
        var nss = namespaces instanceof Array ? namespaces : [namespaces || ns];
        var state = React.useContext(context);
        return [state.createT ? state.createT(nss) : defaultT, state];
    };
    var withT = function (Comp, nss) {
        if (nss === void 0) { nss = ns; }
        if (!Array.isArray(nss))
            nss = [nss];
        return (function (props) {
            var _a = useT(nss), t = _a[0], T = _a[1];
            return React.createElement(Comp, tslib_1.__assign(tslib_1.__assign({}, props), { t: t, T: T }));
        });
    };
    var Trans = function (props) {
        var children = props.children;
        var nss = props.ns instanceof Array ? props.ns : [props.ns || ns];
        var _a = useT(nss), t = _a[0], T = _a[1];
        return (typeof children === 'function'
            ? children(t, T)
            : children instanceof Array
                ? React.createElement.apply(React, tslib_1.__spreadArrays([React.Fragment, null], children.map(function (item) {
                    return typeof item === 'function'
                        ? item(t)
                        : typeof item === 'string'
                            ? t(item)
                            : item || null;
                }))) : typeof children === 'string'
                ? t(children)
                : children) || null;
    };
    return {
        Consumer: Consumer,
        Provider: Provider,
        context: context,
        useT: useT,
        Trans: Trans,
        withT: withT,
        T: defaultT,
    };
};
exports.default = exports.createTranslations;
